import { cn } from '../../helpers/utils.js'
import YouTube from 'react-youtube'

export function YouTubePlayer({ youTubeId, className }: { youTubeId?: string; className?: string }) {
  //   const onReady = event => {
  //     // event.target.playVideo();
  //   }

  return youTubeId ? (
    <YouTube
      className={cn('relative size-full overflow-hidden rounded-2xl', className)}
      videoId={youTubeId}
      opts={{
        playerVars: { autoplay: 1, rel: 0, mute: 1 },
        width: '100%',
        height: '100%',
      }}
    />
  ) : null
}
